<template>
  <div id="contenedor-agregar-responsable-proyecto">
    <v-form
      v-model="formularioValido"
      ref="agregarResponsableProyecto">
      <CustomAutocomplete
        v-model="responsable.idFuncionario"
        label="Funcionario"
        :items="listadoFuncionarios"
        item-text="nombre"
        item-value="id"
        clearable
        :rules="[mixReglas.requerido]">
      </CustomAutocomplete>
      <v-row justify="center" align="center">
        <v-checkbox
        v-model="responsable.esLider"
        label="¿Es lider?">
      </v-checkbox>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import mixProyectosResponsables from './mixProyectosResponsables';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';

export default {
  name: 'AgregarResponsableProyecto',
  mixins: [mixProyectosResponsables],
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomAutocomplete,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      responsable: {
        idProyecto: this.idProyecto,
        idFuncionario: null,
        esLider: false,
      },
    };
  },
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
  },
  methods: {
    async guardarResponsales() {
      await this.mixGuardarResponsales();
    },
    cerrar() {
      this.$refs.agregarResponsableProyecto.reset();
      this.$emit('cerrar');
    },
  },
  watch: {
    formularioValido: {
      handler(valor) {
        this.$emit('formularioValido', valor);
      },
    },
    enviandoFormulario: {
      handler(valor) {
        this.$emit('enviandoFormulario', valor);
      },
    },
  },
  computed: {
    listadoFuncionarios() {
      if (!this.funcionarios || !this.proyectoResponsables) return [];
      const idsProyectoResponsables = this.proyectoResponsables
        .slice()
        .map((responsable) => responsable.idFuncionario);
      const funcionariosFiltrados = this.funcionarios
        .filter((funcionario) => !idsProyectoResponsables
          .includes(funcionario.id));
      return [...funcionariosFiltrados];
    },
  },
};
</script>

<style lang="scss">

</style>
